import * as types from "./actionTypes.js";

// TODO: Is this action necessary? I don't see it being used anywhere.
export function fetchFindResourceCollection() {
    return {
      type: types.FETCH_SELECTED_RESOURCE_COLLECTION
    };
}

export function updateResourceCollectionSelected(payload) {
    return {
        type: types.UPDATE_SELECTED_RESOURCE_COLLECTION,
        payload
    };
}
